$(document).ready(function(){
    $('[cca-spotlight-video]').each(function(){
        var $this = $(this);
        var $playBtn = $this.find('.play-button');
        var $iframe = false;

        setTimeout(function(){
            $iframe = $this.find('.flex-video > iframe');
            $iframe[0].src += '&enablejsapi=1';
        },100);

        $playBtn.on('click', function(e){
            if(!$iframe) return;

            $this.find('> *:not(.flex-video)').fadeOut(500, function() {
                $iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}','*');
            });
        });
    });
});